import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/index.vue'
import Write from './views/write.vue'
import VideoView from './views/videoView.vue'
import Login from './views/login.vue'
import ImageView from './views/imageView.vue'
import RegionSelect from './views/regionSelect.vue'
import ImageSynthesis from './views/imageSynthesis.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: 'vue组件-移动端',
        noBack: true
      }
    },{
      path: '/write',
      name: 'Write',
      component: Write,
      meta: {
        title: '签名板'
      }
    },{
      path: '/videoView',
      name: 'VideoView',
      component: VideoView,
      meta: {
        title: '上传视频'
      }
    },{
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: '登录'
      }
    },{
      path: '/imageView',
      name: 'ImageView',
      component: ImageView,
      meta: {
        title: '上传图片'
      }
    },{
      path: '/regionSelect',
      name: 'RegionSelect',
      component: RegionSelect,
      meta: {
        title: '地区选择'
      }
    },{
      path: '/imageSynthesis',
      name: 'ImageSynthesis',
      component: ImageSynthesis,
      meta: {
        title: '图片合成'
      }
    }
  ]
})
